function initSlider(root) {
  if (!root || root.dataset.sliReady) return;
  root.dataset.sliReady = '1';

  const track = root.querySelector('[data-sli-track]');
  const prevBtn = root.querySelector('[data-sli-prev]');
  const nextBtn = root.querySelector('[data-sli-next]');
  if (!track || !prevBtn || !nextBtn) return;

  function stepPx() {
    const first = track.querySelector('.sli-slide');
    if (!first) return 0;
    const cs = getComputedStyle(track);
    const gap = parseFloat(cs.gap || cs.columnGap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function update() {
    const max = track.scrollWidth - track.clientWidth;
    const x = track.scrollLeft;
    prevBtn.disabled = x <= 2;
    nextBtn.disabled = x >= max - 2;
  }

  prevBtn.addEventListener('click', () => track.scrollBy({ left: -stepPx(), behavior: 'smooth' }));
  nextBtn.addEventListener('click', () => track.scrollBy({ left: stepPx(), behavior: 'smooth' }));
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
}

function initAllSliders() {
  document.querySelectorAll('.sli-wrap').forEach(initSlider);
}

document.addEventListener('DOMContentLoaded', initAllSliders);
document.addEventListener('shopify:section:load', initAllSliders);
document.addEventListener('shopify:section:reorder', initAllSliders);
